let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fR1sL")).then(() => parcelRequire('cegX4'));